import React, { useEffect } from 'react';
import ButtonSession from './buttons/ButtonSession';
import { locales } from '../translations/locales';

const HeaderBar = (props) => {
    const { socket, setMenuOpen, session, locale, setLocale, theme } = props;

    useEffect(() => {
        //
    }, [session, theme]);

    return (
        <div className={`headerBar h-${(theme === 'DARK' ? 'dark' : 'light')}`}>
            <span className='headerTitre' onClick={() => document.location = '/'}>
                <img src='/images/modrp.webp' className='m-1' alt='logo' />
                {locales[locale].module}
            </span>
            <span id='screenName'></span>
            <ButtonSession socket={socket} session={session} setMenuOpen={setMenuOpen} locale={locale} setLocale={setLocale} theme={theme} />
        </div>
    );
};

export default HeaderBar;
